<template>
  <div>
    <!-- Delete Model -->
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteUser" />

    <!-- Edit modal -->
    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      title="Edit User"
      @ok="updateItem()"
    >
      <b-card-text>
        <br />
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col cols="12" md="12">
            <h4>Patient Name</h4>
          </b-col>
          <b-col cols="12" md="12">
            <h2></h2>
          </b-col>
          <b-col md="">
            <b-form-group label="First Name" label-for="firstName">
              <b-form-input v-model="EditForm.first_name" placeholder="" />
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group label="Second Name" label-for="secondName">
              <b-form-input v-model="EditForm.second_name" placeholder="" />
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group label="Third Name" label-for="thirdName">
              <b-form-input v-model="EditForm.third_name" placeholder="" />
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group label="Fourth Name" label-for="forthName">
              <b-form-input v-model="EditForm.forth_name" placeholder="" />
            </b-form-group>
          </b-col>
          <b-col md="">
            <b-form-group label="Nickname" label-for="Nickname">
              <b-form-input v-model="EditForm.nickname" placeholder="" />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Edit Patient's Mother name -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col cols="12" md="12">
            <h4>Patient's Mother Name</h4>
          </b-col>
          <b-col cols="12" md="12">
            <h2></h2>
          </b-col>
          <b-col md="3">
            <b-form-group label="First Name" label-for="firstName">
              <b-form-input
                v-model="EditForm.first_mother_name"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Second Name" label-for="secondName">
              <b-form-input
                v-model="EditForm.second_mother_name"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Third Name" label-for="thirdName">
              <b-form-input
                v-model="EditForm.third_mother_name"
                placeholder=""
              />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group label="Fourth Name" label-for="forthName">
              <b-form-input
                v-model="EditForm.forth_mother_name"
                placeholder=""
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Edit National ID and Phone No. -->

        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>

          <b-col cols="12" md="12">
            <h4>Phone Number</h4>
          </b-col>
          <b-col md="5">
            <b-form-group label="Phone Number" label-for="phoneNumber">
              <b-form-input
                v-model="EditForm.phone"
                placeholder="Enter Phone No."
              />
            </b-form-group>
          </b-col>
          <b-col md="5">
            <b-form-group
              label="Second Phone Number (not required)"
              label-for="secondPhoneNumber"
            >
              <b-form-input
                v-model="EditForm.second_phone"
                placeholder="Enter Second Phone No."
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>

          <b-col md="5">
            <h4>Age</h4>
            <b-form-group label="Patient Age" label-for="age">
              <b-form-input v-model="EditForm.age" placeholder="Enter Age" />
            </b-form-group>
          </b-col>

          <b-col md="5">
            <h4>National ID</h4>
            <b-form-group label="National ID" label-for="nationalID">
              <b-form-input
                v-model="EditForm.national_id"
                placeholder="Enter ID"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col md="3">
            <h4>Address</h4>
            <b-form-group label="Province" label-for="Province">
              <v-select
                v-model="city"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="cities"
                placeholder="Enter Province"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <h4></h4>
            <br />
            <b-form-group label="Patient Address" label-for="patientAddress">
              <b-form-input
                v-model="EditForm.adderss"
                placeholder="Enter Patient Address"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
    </b-modal>

    <!-- Search -->
    <b-card no-body>
      <!-- Search Patient Name -->
      <div class="m-2">
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t('common.search') }}</h2>
            <br />
          </b-col>

          <b-col md="6">
            <b-form-group
              :label="$t('reception.patient-name')"
              label-for="Name"
            >
              <b-form-input
                v-model="searchVar"
                :placeholder="$t('reception.patient-name')"
              />
              <!-- @input="patientSearch()"  -->
            </b-form-group>
          </b-col>
        </b-row>
      </div>

      <!-- Data Table  -->
      <b-table
        :items="this.patientsData"
        responsive
        :fields="tableColumns"
        primary-key="id"
        show-empty
        empty-text="No matching patients found"
        class="position-relative"
        v-if="!loading"
      >
        <!-- Column: Phone -->
        <template #cell(Phone)="data">
          <span class="text-nowrap">
            {{ data.item.phone }}
          </span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap d-flex">
            <!-- @click="printId(data.item.id)" -->
            <button
              pill
              varient="outline-secondary"
              class="button-preview"
              @click="
                $router.push({
                  name: 'Reception-patient-preview',
                  params: { id: data.item.id },
                })
              "
            >
              {{ $t('common.preview') }}
            </button>
            <ActionsButtons
              :noEdit="true"
              deletePerm="delete-patient"
              editPerm="update-patient"
              @editToggle="show(data.item)"
              @deleteToggle="deleteModel(data.item)"
            />
            <!-- Dropdown -->
            <!-- <b-dropdown
              variant="link"
              toggle-class="p-0"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item @click="show(data.item)">
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">Edit</span>
              </b-dropdown-item>
              <b-dropdown-item @click="deleteModel(data.item)">
                <feather-icon icon="TrashIcon" />
                <span class="align-middle ml-50">Delete</span>
              </b-dropdown-item>
            </b-dropdown> -->
          </div>
        </template>
      </b-table>

      <template v-if="loading">
        <div>
          <div class="d-flex justify-content-center mb-1">
            <b-spinner :label="$t('common.loading')" />
          </div>
        </div>
      </template>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted"
              >{{ $t('common.showing') }} 1 {{ $t('common.to') }} 10
              {{ $t('common.patients') }}</span
            >
          </b-col>

          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="index()"
          >
            <b-pagination
              v-model="page"
              :total-rows="this.pathientsNumber"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
  <!-- Table Container Card -->
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
  BAlert,
  VBModal,
  BCardText,
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue';
import { debounce } from 'lodash';
import index from 'vue-prism-component';
import ActionsButtons from '@/components/common/ActionsButtons.vue';
import DeleteModal from '@/components/modals/DeleteModal.vue';
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BAlert,
    BCardText,
    StatisticCardHorizontal,
    DeleteModal,
    ActionsButtons,
  },

  data() {
    return {
      tableColumns: [
        { key: 'name', label: this.$t('common.name'), sortable: true },
        {
          key: 'patient_no',
          label: this.$t('reception.patient-no'),
          sortable: true,
        },

        {
          key: 'birth_date',
          label: this.$t('reception.birth-date'),
          sortable: true,
        },
        { key: 'Phone', label: this.$t('reception.phone'), sortable: true, class: "text-nowrap" },
        {
          key: 'mother_name',
          label: this.$t('reception.patient-mother-name'),
          sortable: true,
        },
        { key: 'Actions', label: this.$t('common.actions') },
      ],

      EditForm: {
        first_name: '',
        second_name: '',
        third_name: '',
        forth_name: '',
        nickname: '',
        first_mother_name: '',
        second_mother_name: '',
        third_mother_name: '',
        forth_mother_name: '',
        national_id: '',
        phone: '',
        second_phone: '',
        age: '',
        adderss: '',
        _method: 'PUT',
      },
      errorForm: {
        first_name: '',
        second_name: '',
        third_name: '',
        forth_name: '',
        nickname: '',
        first_mother_name: '',
        second_mother_name: '',
        third_mother_name: '',
        forth_mother_name: '',
        national_id: '',
        card_type: '',
        phone: '',
        second_phone: '',
        age: '',
        adderss: '',
        birthday: '',
        city_id: '',
      },
      take: 10,
      loading: true,
      selected: '',
      option: [],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: '',
      sortBy: 'id',
      isSortDirDesc: true,
      page: 1,
      params: {
        form: {},
        path: '',
      },
      cities: [],
      city: 'Baghdad',
      patientsData: [],
      pathientsNumber: 0,
      deleteForm: [],
      statusFilter: null,
      filterData: {
        first_name: '',
        second_name: '',
        third_name: '',
        forth_name: '',
        first_mother_name: '',
        second_mother_name: '',
        third_mother_name: '',
        forth_mother_name: '',
        national_id: '',
        patient_id: '',
        nickname: '',
      },
      searchForm: {
        full_name: '',
      },
      searchVar: '',
    };
  },
  watch: {
    searchVar: debounce(function () {
      if (this.searchVar == '') {
        index();
      } else {
        // this.patientSearch()
      }
    }, 1000),
  },
  mounted() {
    this.index();
  },
  methods: {
    show(item) {
      this.EditForm.id = item.id;
      this.EditForm.first_name = item.first_name;
      this.EditForm.second_name = item.second_name;
      this.EditForm.third_name = item.third_name;
      this.EditForm.forth_name = item.forth_name;
      this.EditForm.nickname = item.nickname;
      this.EditForm.first_mother_name = item.first_mother_name;
      this.EditForm.second_mother_name = item.second_mother_name;
      this.EditForm.third_mother_name = item.third_mother_name;
      this.EditForm.forth_mother_name = item.forth_mother_name;
      this.EditForm.national_id = item.national_id;
      this.EditForm.phone = item.phone;
      this.EditForm.second_phone = item.second_phone;
      this.EditForm.age = item.age;
      this.EditForm.adderss = item.adderss;
      if (this.requestPermission.includes('get-city')) {
        this.getCities();
      } else {
        this.cities = [
          'Baghdad',
          'Basra',
          'Erbil',
          'Mosul',
          'Najaf',
          'Not Specified',
        ];
      }
      this.$bvModal.show('modal-edit');
    },
    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show('modal-delete');
    },
    async index() {
      // after each time the search button being pressed the loading should be back again
      this.loading = true;
      // check if there are any null value in the obj we sending
      for (const [key, value] of Object.entries(this.filterData)) {
        if (value == null) {
          this.filterData[key] = '';
        }
      }
      await this.getList(
        `/patient?page=${this.page}&take=${this.take}&sort=-id`
      );
      this.pathientsNumber = this.all_data.total;
      this.patientsData = this.all_data.data;
      this.loading = false;
    },
    patientSearch() {
      // this.loading=true;
      this.searchForm.full_name = this.searchVar;
      (this.params.form = this.searchForm),
        (this.params.path = `/elastic/patient/search`),
        this.$store
          .dispatch('create', this.params)
          .then((response) => {
            this.pathientsNumber = response.data.total;
            let patientsList = response.data.data;
            const patientData = [];
            patientsList.map((element) => {
              if (element.third_name == null) element.third_name = '';
              if (element.forth_name == null) element.forth_name = '';
              if (element.nickname == null) element.nickname = '';
              if (element.second_mother_name == null)
                element.second_mother_name = '';
              patientData.push(element);
            });
            this.patientsData = patientData;
            this.loading = false;
          })
          .catch((error) => {
            if (error.response.status === 400) {
            }
          });
    },

    async getCities() {
      await this.getList(`/city`);
      for (let item in this.all_data.data) {
        this.cities.push(this.all_data.data[item].name);
      }
    },
    updateItem() {
      if (this.city) {
        this.EditForm.city_id = (this.cities.indexOf(this.city) + 1).toString();
      }
      for (let item in this.errorForm) {
        this.errorForm[item] = '';
        if (this.EditForm[item] == '' || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      (this.params.form = this.EditForm),
        (this.params.path = `/patient/${this.EditForm.id}`),
        this.$store
          .dispatch('update', this.params)
          .then((response) => {
            this.index();
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
    deleteUser() {
      this.$store
        .dispatch('delete', `/patient/${this.deleteForm.id}`)
        .then((response) => {
          this.index();
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Delete Success',
              icon: 'success',
              variant: 'info',
              text: 'deleted ' + this.deleteForm.first_name + ' successfully',
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Error',
              variant: 'danger',
              text: 'Error deleting ' + this.deleteForm.first_name,
            },
          });
        });
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
